export { Attendances as default } from "./attendances";
